// Nav entry of Reading (shell/nav.ts collects every routes/*.nav.ts; `order` places it in the rail, the tabs and Lisää).
// Lukupino: texts in which nearly every word is steady for you, read aloud (engine pedagogy/reading.ts).
import { defineNav } from '../shell/nav-entry';

export const nav = defineNav({
  id: 'reading',
  path: '/reading',
  icon: 'reading',
  group: 'practice',
  phone: 'more',
  order: 350,
  load: () => import('./Reading'),
});
